/**
 * Client-side mirror of supabase/functions/_shared/oauth/clients.ts —
 * exact-match redirect_uri check, host-insensitive, path-sensitive.
 *
 * Keep these two implementations in lock-step. Any change to either MUST
 * be applied to the other in the same PR.
 */
export function isRegisteredRedirectUri(candidate: string, registered: string[]): boolean {
  let candUrl: URL;
  try {
    candUrl = new URL(candidate);
  } catch {
    return false;
  }
  const candHost = candUrl.host.toLowerCase();
  const candTail = candUrl.pathname + candUrl.search + candUrl.hash;
  const candProto = candUrl.protocol;
  for (const reg of registered) {
    let regUrl: URL;
    try {
      regUrl = new URL(reg);
    } catch {
      continue;
    }
    if (
      regUrl.protocol === candProto &&
      regUrl.host.toLowerCase() === candHost &&
      regUrl.pathname + regUrl.search + regUrl.hash === candTail
    )
      return true;
  }
  return false;
}
